import { z } from "zod";
import { ORDER_TYPES, PAYMENT_METHODS, ORDER_STATUSES } from "../constants/enums.js";
export const PlaceOrderItemSchema = z.object({
    menuItemId: z.string().min(1),
    qty: z.number().int().min(1).max(99),
    note: z.string().max(200).optional(),
    optionIds: z.array(z.string().min(1)).optional().default([]),
    optionTexts: z.record(z.string(), z.string().max(500)).optional().default({}),
});
export const PlaceOrderInputSchema = z
    .object({
    type: z.enum(ORDER_TYPES),
    address: z.string().max(300).optional(),
    addressId: z.string().optional(),
    lat: z.number().min(-90).max(90).optional(),
    lng: z.number().min(-180).max(180).optional(),
    distanceKm: z.number().min(0).max(200).optional(),
    items: z.array(PlaceOrderItemSchema).min(1).max(50),
    /** IDs of any bundle deals applied to this order. Server validates them and applies the savings. */
    bundleIds: z.array(z.string().min(1)).max(10).optional(),
    voucherCode: z.string().trim().toUpperCase().max(40).optional(),
    /** Stacked vouchers — up to 3 slots (merchant + platform, both subtotal-target, plus one delivery-fee-target). */
    voucherCodes: z.array(z.string().trim().toUpperCase().max(40)).max(3).optional(),
    specialNote: z.string().max(300).optional(),
    contactName: z.string().max(100).optional(),
    contactPhone: z.string().max(20).optional(),
    paymentMethod: z.enum(PAYMENT_METHODS),
    /** The total the customer was shown. If the server now prices the order differently the order is refused (PRICE_CHANGED) instead of charging something else. */
    expectedTotal: z.string().regex(/^\d{1,8}(\.\d{1,2})?$/).optional(),
})
    .refine((v) => v.type === "pickup" || !!v.address || !!v.addressId, {
    message: "address_required_for_delivery",
    path: ["address"],
});
export const UpdateOrderStatusSchema = z.object({
    status: z.enum(ORDER_STATUSES),
    note: z.string().max(300).optional(),
});
export const AcceptOrderSchema = z.object({
    estMinutes: z.number().int().min(1).max(240),
});
export const ValidateVoucherSchema = z.object({
    code: z.string().trim().toUpperCase().min(1).max(40),
    subtotal: z.string({ required_error: "subtotal is required" }).min(1, "subtotal is required")
        .pipe(z.coerce.number({ invalid_type_error: "subtotal must be a number" }).nonnegative("subtotal must be non-negative")),
});
//# sourceMappingURL=order.js.map